<template>
  <v-container fluid class="test-data-generation mt-3 mx-1">
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <h2 class="primary--text font-weight-bold pt-5 pl-2">
            {{ $t('book/admin:testdata.title') }}
          </h2>
          <v-card
            elevation="0"
            flat
            tile
          >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="4">
                  <CustomerTypeAhead
                    ref="customerTypeahead"
                    :value="customer"
                    @input="customer = $event"
                    :label="$t('common:customer')"
                    required
                  />
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                      :items="processes"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ bottom: true, offsetY: true }"
                      v-model="process"
                      outlined
                      :label="$t('book/admin:testdata.process-to-use')"
                      clearable
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card
            elevation="0"
            flat
            tile
            class="pl-3 pt-3 pb-md-3"
          >

            <v-btn
                color="grey"
                class="mr-3 mb-3 mb-md-0 white--text"
                rounded
                elevation="0"
                @click="$router.go(-1)"
            >{{ $t('buttons:back') }}
            </v-btn>

            <BaseButton
              color="primary"
              :btn-text="$t('book/admin:testdata.btn')"
              @clickedButton="generateTestData"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import CustomerTypeAhead from "@/modules/core/components/CustomerTypeAhead";

import TestDataService from "@/modules/book/services/testdata-service";
import Utils from "../../../core/services/utils";
import ProcessService from "@/modules/book/services/process/impl/process-service";
import BaseButton from "@/modules/core/components/Base/BaseButton";
import {ruleRequired} from "@/modules/core/services/rules";

export default {
  name: 'TestDataGeneration',
  components: {
    BaseButton,
    CustomerTypeAhead
  },
  data() {
    return {
      customer: null,
      processes: [],
      process: null
    }
  },
  methods: {
    ruleRequired,
    generateTestData() {
      if (!this.$refs.form.validate()) {
        return;
      }

      TestDataService.generateCustomerTestData(this.customer, this.process,
        () => {
          Utils.showSuccessSnackbar(this.$t('book/admin:testdata.snackbar-success'));
          this.customer = null;
          this.process = null;
          this.$refs.form.reset();
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('book/admin:testdata.snackbar-failure'))
          this.$logger.error("Failed to generate test data for customer, because: " + error);
        }
      )
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation();
      });
    }
  },
  created() {
    ProcessService.readAllFromAPI(
        (res) => {
          this.processes = res.data;
        }
    )
  }
}
</script>
